import ActionsMenu, { ActionMenuItem } from "components/ActionsMenu";
import { isCompletedStatus, isInactiveStatus } from "pages/crawler/constants/jobStatusGroups";
import type { StatusDisplay } from "pages/crawler/utils/crawlerStatusUtils";

export const JobActionsDropdown = ({
  jobId,
  jobStatus,
  outputFormat,
  onAction,
}: {
  jobId: string;
  jobStatus?: StatusDisplay;
  outputFormat?: string;
  onAction: (action: string, id: string) => void;
}) => {
  // Cancel is disabled once the job is no longer active; download only once complete.
  const isCancelDisabled = isInactiveStatus(jobStatus);
  const isDownloadDisabled = !isCompletedStatus(jobStatus);

  const items: ActionMenuItem[] = [
    {
      label: `Download results (${outputFormat || "JSON"})`,
      onClick: () => onAction("download", jobId),
      disabled: isDownloadDisabled,
    },
    {
      label: "View Details",
      onClick: () => onAction("view", jobId),
    },
    {
      label: "Cancel Job",
      onClick: () => onAction("cancel", jobId),
      disabled: isCancelDisabled,
      destructive: true,
    },
  ];

  return <ActionsMenu items={items} ariaLabel="Job actions" />;
};

export default JobActionsDropdown;
